import { Component } from "react"
import PropTypes from "prop-types"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import { connectionShape } from "app/lib/shared_prop_types"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"

export default class GetMoreAppletCard extends Component {
  render() {
    return (
      <div className="explore-tile">
        <li
          className="my-web-applet-card web-applet-card"
          ref={el => {
            this.scrollObserverEl = el
          }}
        >
          <SmallAppletCard appletPath={appletOrConnectionPath(this.props.applet)} applet={this.props.applet} />
        </li>
      </div>
    )
  }
}

GetMoreAppletCard.propTypes = {
  applet: connectionShape.isRequired,
  term: PropTypes.string,
  position: PropTypes.number.isRequired,
}
